import React from 'react';

function isBlockedByAdmin(item) {
    if (item?.considerAdminChanges) {
        if (item?.blockedByAdmin === 1) {
            return true;
        }
    }
    return false;
}

function getCategoryStatus(item) {
    if(isBlockedByAdmin(item)) {
        return ['text-blue-50 icon-check-fill', 'text-blue-50 icon-info-triangle-fill', 'text-danger border-danger icon-ban']
    } else if(item?.categoryStatus === 0) {
        return ['text-success border-success icon-check-fill', 'text-blue-50 icon-info-triangle-fill', 'text-blue-50 icon-ban']
    } else if(item?.categoryStatus === 1) {
        return ['text-blue-50 icon-check-fill', 'text-blue-50 icon-info-triangle-fill', 'text-danger border-danger icon-ban']
    } else if (item?.categoryStatus === 2) {
        return ['text-blue-50 icon-check-fill', 'text-warning border-warning icon-info-triangle-fill', 'text-blue-50 icon-ban']
    } else {
        return ['text-blue-50', 'text-blue-50', 'text-blue-50']
    }
}

const WebCategoryRow = ({ item, handleWebCategoryChange, getLangTranslation }) => {
    return (
        <tr>
            <td className="v-middle">
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id={item?.id}
                        name={item?.id}
                        checked={item?.isChecked || 0}
                        disabled={item?.considerAdminChanges && item?.blockedByAdmin === 1}
                        onChange={(e) => handleWebCategoryChange(e)}
                    />
                    <label className="form-check-label text-uppercase" htmlFor={item?.id}>
                        {item?.name}
                    </label>
                </div>
            </td>
            <td className="v-middle">
                <div className="d-inline-flex align-items-center gap-6">
                    {
                        getCategoryStatus(item)?.map((icon, index) => {
                            return (
                                <i 
                                    className={`icon-check-fill fs-5 border rounded-circle ${icon}`} key={index}
                                />
                            )
                        })
                    }
                    {/* <i className={`icon-check-fill fs-5 border rounded-circle ${getCategoryStatus(item)}`} />
                    <i className={`icon-info-triangle-fill fs-5 border rounded-circle ${getCategoryStatus(item)}`} />
                    <i className={`icon-ban fs-5 border rounded-circle ${getCategoryStatus(item)}`} /> */}
                </div>
            </td>
            {/* <td className="v-middle">
                <div className="d-inline-flex align-items-center gap-6">
                   {(item?.considerAdminChanges && item?.blockedByAdmin === 1) ? getLangTranslation("SET_RULES_WEB_CATEGORY_BLOCKED_BY_ADMIN", "Category blocked by admin") : "---"}
                </div>
            </td> */}
        </tr>
    )
}

export default WebCategoryRow